import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Mousewheel } from 'swiper/modules';

import useMediaQuery from 'hooks/useMediaQuery';

import ModalContent from 'components/website/YoutubePopUp/ModalContent';
import SlidePaymentLink from './SlidePaymentLink';
import SlideNairo from './SlideNairo';

import './slider.scss';

const Slider = () => {
  const sliderChild = useRef();
  const [height, setHeight] = useState();
  const [showModal, setShowModal] = useState(false);
  const [disablePointerEvents, setDisablePointerEvents] = useState(false);
  const isMobile = useMediaQuery('screen and (min-width: 1px) and (max-width: 513px)');
  const isTablet = useMediaQuery('screen and (min-width: 514px) and (max-width: 1023px)');
  const isDesktop = useMediaQuery('screen and (min-width: 1024px)');

  const videoData = Object.freeze({
    videoMobile: 'https://www.youtube.com/embed/am3N52AL70A?si=H1lwphrpQWp9CNQM&autoplay=1',
    videoTablet: 'https://www.youtube.com/embed/aHmFyiyFnt8?si=pIi7cuEnf3R98Jiv&autoplay=1',
    videoDesktop: 'https://www.youtube.com/embed/aHmFyiyFnt8?si=pIi7cuEnf3R98Jiv&autoplay=1',
  });

  const { videoMobile, videoTablet, videoDesktop } = videoData;

  const handleModal = () => {
    setShowModal(!showModal);
  };

  const NUMBER_OF_SLIDES = [
    {
      key: '1',
      sm: <SlideNairo size="sm" handleModal={handleModal} />,
      md: <SlideNairo size="md" handleModal={handleModal} />,
      xx: <SlideNairo size="xx" height={height} handleModal={handleModal} />,
    },
    {
      key: 'a',
      sm: <SlidePaymentLink size="sm" />,
      md: <SlidePaymentLink size="md" />,
      xx: <SlidePaymentLink size="xx" refValue={sliderChild} />,
    },
  ];

  const resizeSwiper = () => {
    if (window.innerWidth >= 1280) {
      setHeight(sliderChild.current.clientHeight);
    }
  };

  return (
    <section className="hero-home">
      <Swiper
        className={`hero ${disablePointerEvents ? 'hero-pointer-events' : ''}`}
        style={{
          height,
          minHeight: height,
        }}
        modules={[Pagination, Mousewheel]}
        direction="vertical"
        speed={1000}
        parallax
        pagination={{
          el: '.swiper-hero-pagination',
          clickable: true,
        }}
        mousewheel
        onSlideChangeTransitionEnd={swiper => {
          const isLast = swiper.activeIndex === NUMBER_OF_SLIDES.length - 1;
          swiper.params.mousewheel.releaseOnEdges = isLast;
          swiper.params.touchReleaseOnEdges = isLast;
          setDisablePointerEvents(isLast);
        }}
        onResize={() => {
          resizeSwiper();
        }}
      >
        {NUMBER_OF_SLIDES.map(({ key, sm, md, xx }) => (
          <SwiperSlide key={key}>
            <div className="show-mobile">{sm}</div>
            <div className="show-tablet">{md}</div>
            <div className="show-desktop">{xx}</div>
          </SwiperSlide>
        ))}
        <div className="swiper-hero-pagination color-blue"></div>
      </Swiper>
      <div className="yt-component-one">
        {isMobile && showModal && (
          <ModalContent hideTitle showModal={showModal} handleModal={handleModal} video={videoMobile} />
        )}
        {isTablet && showModal && (
          <ModalContent hideTitle showModal={showModal} handleModal={handleModal} video={videoTablet} />
        )}
        {isDesktop && showModal && (
          <ModalContent hideTitle showModal={showModal} handleModal={handleModal} video={videoDesktop} />
        )}
      </div>
    </section>
  );
};

export default Slider;
